import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './styles/common.less'
import './styles/global.less'
import './assets/iconfont/iconfont.css'

// import './assets/iconfont/iconfont.ttf' 
import Vant from 'vant'
import 'vant/lib/index.css';
import 'vant/lib/icon/local.css';
import './utils/vant'
// import Vconsole from 'vconsole';
// new Vconsole();
Vue.config.productionTip = false
Vue.prototype.$IMG_PATH = process.env.VUE_APP_IMG_PATH

const IsObject = v => v !== null && typeof v === 'object'
const JsonParse = (json, expect) => {
  if (IsObject(json)) return json
  const res = expect || []
  try {
    return JSON.parse(json) || res
  } catch {
    return res
  }
}
const point = JsonParse(window.localStorage.getItem('point'), {})
const cateContent = window.localStorage.getItem('cateContent')
const form = JsonParse(window.localStorage.getItem('form'), {})
const departList = JsonParse(window.localStorage.getItem('departList'))
store.state.cate.point = point
store.state.cate.cateContent = cateContent
store.state.cate.form = form
store.state.cate.departList = departList
console.log('sttt', store, point)


Vue.use(Vant)
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
